import { defineStore } from "pinia";
import { computed } from "vue";
import type {
    ProductSearchRequest
} from "@/api/modules/autoQ/productSearch/types.ts";
import {
    useProductSearchFilterParamsStore
} from "@/stores/productSearch/productSearchFilterParamsStore";
import {
    useProductSearchPaginationStore
} from "@/stores/productSearch/productSearchPaginationStore";
import {
    useProductSearchActiveBusinessUnit
} from "@/stores/productSearch/productSearchActiveBusinessUnit";
import {
    useProductSearchSortStore
} from "@/stores/productSearch/productSearchSortStore";

export const useProductSearchPayloadStore = defineStore("productSearchPayloadStore", () => {
    const filterParamsStore = useProductSearchFilterParamsStore();
    const paginationStore = useProductSearchPaginationStore();
    const activeBusinessUnitStore = useProductSearchActiveBusinessUnit();
    const sortStore = useProductSearchSortStore();


    const payload = computed<ProductSearchRequest>(() => ({
        conditions: {
            ...filterParamsStore.filterParams,
            fulltext: filterParamsStore.filterParams.fulltext ? filterParamsStore.filterParams.fulltext : undefined,
            businessUnitName: !!activeBusinessUnitStore.activeBusinessUnitName ? [activeBusinessUnitStore.activeBusinessUnitName] : undefined,
        },
        pageFrom: paginationStore.paginationData.pageFrom || 0,
        pageSize: paginationStore.paginationData.pageSize || 10,
        sortOptions: sortStore.sortOptionsPayload
    }));

    return { payload };
});